import Send from '../send';

const DEFAULT_API = '/v1/visit-info';
export default {

    createVisitInfo(visitorApplicationInfo) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'POST',
            data : visitorApplicationInfo
        });
    },

    createVisitorSurvey(surveyInfo) {
        return Send({
            url : `${DEFAULT_API}/survey`,
            method : 'POST',
            data : surveyInfo
        });
    },

    createVisitorCertificate(certificateInfo) {
        return Send({
            url : `${DEFAULT_API}/certificate`,
            method : 'POST',
            data : certificateInfo
        });
    },

    createVisitorTerms(visitorInfoSeq, termsInfo) {
        return Send({
            url : `${DEFAULT_API}/survey`,
            method : 'POST',
            data : termsInfo.map(row => ({...row, visitorInfoSeq : visitorInfoSeq}))
        });
    }
}